// extracted by mini-css-extract-plugin
module.exports = {"favoritesWrapper":"_7924bc6a","folder":"_7a260e8"};